import {
    IBoletosRequest,
    IBoletosViaContaRequest,
    IEnviarBoletoPorEmailSienge,
    IGerarBoletoIntegral,
    IGerarLinkBoletoSienge,
    IGestaoBoletoFiltro,
    IGestaoBoletoResponse,
} from "../../../Interfaces/Cobranca/Boleto/BoletoInterface";
import {
    AlterarDataVencimentoBoletosService,
    EnviarBoletoPorEmailSiengeService,
    GerarBoletoIntegralService,
    GerarBoletoService,
    GerarBoletoViaContaService,
    GerarLinkBoletoSegundaViaSiengeService,
    ListarBoletosGestaoService,
} from "../../../Services/Cobranca/Boleto/BoletoService";
import { ValidationErr } from "../../../Validations/ValidationError";

import toastr from "toastr";
import { Controller } from "../../Controller";

export async function ListarBoletosGestaoController(
    requestBody: IGestaoBoletoFiltro
) {
    const Response = await ListarBoletosGestaoService(requestBody)
        .then((response) => {
            return response.data as IGestaoBoletoResponse;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return Response;
}

export async function ExportarExcelBoletosGestaoController(
    requestBody: IGestaoBoletoFiltro
) {
    const Response = await ListarBoletosGestaoService({
        ...requestBody,
        NR_PAGINA: 0,
    })
        .then((response) => {
            return response.data as Blob;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return Response;
}

export async function GerarBoletoController(requestBody: IBoletosRequest) {
    return Controller(GerarBoletoService(requestBody));
}

export async function AlterarDataVencimentoBoletosController(
    SeuNum_Rea: number,
    Banco_Rea: number,
    Empresa_rea: number,
    DtVencimentoNovo: string,
    DtCalculo: string
) {
    return Controller(
        AlterarDataVencimentoBoletosService(
            SeuNum_Rea,
            Banco_Rea,
            Empresa_rea,
            DtVencimentoNovo,
            DtCalculo
        )
    );
}

export async function GerarBoletoViaContaController(
    requestBody: IBoletosViaContaRequest,
    ID_CONTA: number,
    idTipoCaso: number
) {
    const Response = await GerarBoletoViaContaService(
        requestBody,
        ID_CONTA,
        idTipoCaso
    )
        .then((response) => {
            toastr.success(
                `Boleto${
                    requestBody.LST_PARCELAS.length > 1 ? "s" : ""
                } Gerado${
                    requestBody.LST_PARCELAS.length > 1 ? "s" : ""
                } com Sucesso!`
            );
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return Response;
}

export async function EnviarBoletoPorEmailSiengeController(
    req: IEnviarBoletoPorEmailSienge
) {
    return Controller(
        EnviarBoletoPorEmailSiengeService(req),
        "Boleto enviado por e-mail com sucesso!"
    );
}

export async function GerarLinkBoletoSegundaViaSiengeController(
    req: IGerarLinkBoletoSienge
) {
    return Controller(GerarLinkBoletoSegundaViaSiengeService(req));
}

export async function GerarBoletoIntegralController(
    requestBody: IGerarBoletoIntegral
) {
    return Controller(GerarBoletoIntegralService(requestBody));
}
